import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface RelatedPost {
  slug: string;
  title: string;
  category: string;
}

interface RelatedPostsProps {
  currentSlug: string;
  posts: RelatedPost[];
}

export function RelatedPosts({ currentSlug, posts }: RelatedPostsProps) {
  const filteredPosts = posts.filter(post => post.slug !== currentSlug).slice(0, 3);
  
  if (filteredPosts.length === 0) return null;
  
  return (
    <section className="py-12 bg-secondary/30">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-foreground mb-6">Related Articles</h3>
          <div className="grid gap-4">
            {filteredPosts.map((post) => (
              <Card key={post.slug} className="hover:shadow-card-hover transition-smooth">
                <CardContent className="p-4">
                  <Link 
                    to={`/blog/${post.slug}`}
                    className="flex items-center justify-between group"
                  >
                    <div>
                      <span className="text-xs text-primary font-medium">{post.category}</span>
                      <h4 className="text-foreground font-medium group-hover:text-primary transition-colors">
                        {post.title}
                      </h4>
                    </div>
                    <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export const allBlogPosts: RelatedPost[] = [
  { slug: "ai-symptom-checker-hospitals", title: "How AI Symptom Checkers Are Transforming Hospital Triage", category: "AI in Healthcare" },
  { slug: "reduce-er-wait-times", title: "5 Proven Strategies to Reduce Emergency Room Wait Times", category: "Hospital Operations" },
  { slug: "digital-front-door-healthcare", title: "The Digital Front Door: Reimagining Healthcare Access", category: "Digital Health" },
  { slug: "prevent-unnecessary-er-visits", title: "Preventing Unnecessary ER Visits: A Guide for Patients and Providers", category: "Patient Education" },
  { slug: "healthcare-triage-automation", title: "Healthcare Triage Automation: The Future of Patient Assessment", category: "Healthcare Technology" },
  { slug: "virtual-healthcare-triage-system", title: "Virtual Healthcare Triage Systems: Transforming Remote Patient Care", category: "Telehealth" },
  { slug: "clinical-decision-support-tool", title: "Clinical Decision Support Tools: Enhancing Healthcare Quality", category: "Clinical Technology" },
  { slug: "patient-intake-software", title: "Patient Intake Software: Streamlining the Healthcare Front Door", category: "Healthcare Operations" },
  { slug: "hospital-triage-automation", title: "Hospital Triage Automation: Revolutionizing Emergency Department Efficiency", category: "Emergency Medicine" },
];
